<template lang="html">
  <div class="wrapper-jexcel" max-height="350px" @keydown.tab.capture.prevent.stop>
    <div id="spreadsheet" ref="spreadsheet" max-height="350px" @click="removeClassErro()"></div>
    <br />
    <v-btn color="success" dark class="mt-5" style="float: left" relative text medium @click="jExcelObj.insertRow()">
      <v-icon left size="30px">mdi-plus-circle</v-icon>
      Adicionar Linha
    </v-btn>
  </div>
</template>

<script>
  import jexcel from 'jexcel';

  export default {
    name: 'Jexcel',

    props: {
      rows: {
        type: Array,
        default: () => []
      },
      columns: {
        type: Array,
        default: () => []
      },
      allowDeleteColumn: {
        type: Boolean,
        default: false
      },
      allowDeleteRow: {
        type: Boolean,
        default: true
      },
      allowRenameColumn: {
        type: Boolean,
        default: false
      },
      allowInsertColumn: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:rows', 'update:columns'],

    data() {
      return {};
    },

    computed: {
      _rows: {
        get() {
          return this.rows;
        },
        set(newValue) {
          this.$emit('update:rows', newValue);
        }
      },
      _columns: {
        get() {
          return this.columns;
        },
        set(newValue) {
          this.$emit('update:columns', newValue);
        }
      },
      jExcelOptions() {
        // https://bossanova.uk/jspreadsheet/v3/docs/quick-reference
        return {
          data: this._rows,
          columns: this._columns,

          allowDeleteColumn: this.allowDeleteColumn,
          allowDeleteRow: this.allowDeleteRow,
          allowRenameColumn: this.allowRenameColumn,
          allowInsertColumn: this.allowInsertColumn,
          allowManualInsertColumn: this.allowInsertColumn,
          allowExport: false,
          lazyLoading: false,
          allowComments: false,

          text: {
            noRecordsFound: 'Nenhum registro encontrado',
            showingPage: 'Mostrando página {0} de {1} entradas',
            show: 'Mostrar',
            entries: 'Entradas',
            insertANewColumnBefore: 'Inserir uma nova coluna a esquerda',
            insertANewColumnAfter: 'Inserir uma nova coluna a direita',
            deleteSelectedColumns: 'Excluir colunas selecionadas',
            renameThisColumn: 'Renomear esta coluna',
            orderAscending: 'Ordem ascendente',
            orderDescending: 'Order decrescente',
            insertANewRowBefore: 'Inserir uma nova linha acima',
            insertANewRowAfter: 'Inserir uma nova linha abaixo',
            deleteSelectedRows: 'Excluir linhas selecionadas',
            editComments: 'Editar comentários',
            addComments: 'Adicionar comentários',
            comments: 'Comentários',
            clearComments: 'Limpar comentários',
            copy: 'Copiar...',
            paste: 'Colar...',
            saveAs: 'Salvar como...',
            // about: 'About',
            areYouSureToDeleteTheSelectedRows: 'Tem certeza de excluir as linhas selecionadas?',
            areYouSureToDeleteTheSelectedColumns: 'Tem certeza de excluir as colunas selecionadas?',
            thisActionWillDestroyAnyExistingMergedCellsAreYouSure:
              'Esta ação irá destruir todas as células mescladas existentes. Você tem certeza?',
            thisActionWillClearYourSearchResultsAreYouSure: 'Esta ação limpará seus resultados de pesquisa. Você tem certeza?',
            thereIsAConflictWithAnotherMergedCell: 'Há um conflito com outra célula mesclada',
            invalidMergeProperties: 'Propriedades mescladas inválidas',
            cellAlreadyMerged: 'Célula já mesclado',
            noCellsSelected: 'Nenhuma célula selecionada'
          }
        };
      }
    },
    mounted: function () {
      //console.log(this.jExcelOptions);
      //console.log(this.$refs["spreadsheet"]);
      const jExcelObj = jexcel(this.$refs['spreadsheet'], this.jExcelOptions);
      // Object.assign(this, jExcelObj); // pollutes component instance
      Object.assign(this, { jExcelObj }); // tucks all methods under jExcelObj object in component instance
      // console.log(this.jExcelObj);
    },
    methods: {
      removeClassErro() {
        const elements = document.querySelectorAll('tbody tr');
        elements.forEach((element) => {
          element.classList.remove('spreadsheet-error');
        });
      }
      //insertRowc() {
      //console.log(this);
      // this.spreadsheet.insertRow();
      //}
    }
  };
</script>
<style>
  .spreadsheet-error {
    color: red !important;
  }
  .jexcel_about {
    display: none !important;
  }
  .jexcel_textarea {
    display: none !important;
  }
</style>
